import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class MockResponsiveHideConditionsService {
  public setupHideCondition(condition: string): Observable<boolean> {
    const hideWidget = false; // do not hide widget in mock
    return of(hideWidget);
  }

  public extractRootNames(condition: string): string[] {
    return [];
  }

  public observeRootFormValue(root: string): Observable<any> {
    return of({});
  }
}
